module.exports = __webpack_public_path__ + "static/media/ic-kakao-talk.4d502449.svg";